import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomMaterialModule } from 'app/custom-material/custom-material.module';
import { AddFromTemplateDialogComponent } from './components/add-from-template-dialog/add-from-template-dialog.component';
import { AddLibraryDialogComponent } from './components/add-library-dialog/add-library-dialog.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { CopyPlanDialogComponent } from './components/copy-plan-dialog/copy-plan-dialog.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { SelectGroupsDialogComponent } from './components/select-groups-dialog/select-groups-dialog.component';
import { SelectUsersDialogComponent } from './components/select-users-dialog/select-users-dialog.component';
import { SelectWeekDialogComponent } from './components/select-week-dialog/select-week-dialog.component';
import { TemplateLibraryItemComponent } from './components/template-library-item/template-library-item.component';
import { CustomPaginator } from './components/user-search/user-search.component';
import { VideoDialogComponent } from './components/video-dialog/video-dialog.component';
import { FilterGroupsPipe } from './pipes/filter-groups.pipe';
import { FilterPlansPipe } from './pipes/filter-plans.pipe';
import { FilterUserLibraryPipe } from './pipes/filter-user-library.pipe';
import { FilterUsersPipe } from './pipes/filter-users.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
  imports: [CommonModule, FormsModule, CustomMaterialModule, FlexLayoutModule, ReactiveFormsModule, BrowserAnimationsModule, MatIconModule],
  declarations: [
    SelectUsersDialogComponent,
    FilterUsersPipe,
    TruncatePipe,
    VideoDialogComponent,
    SelectGroupsDialogComponent,
    FilterGroupsPipe,
    SelectWeekDialogComponent,
    AlertDialogComponent,
    CopyPlanDialogComponent,
    ConfirmationDialogComponent,
    TemplateLibraryItemComponent,
    FilterUserLibraryPipe,
    AddLibraryDialogComponent,
    AddFromTemplateDialogComponent,
    FeedbackComponent,
    SortPipe,
    FilterPlansPipe,
  ],
  exports: [
    SelectUsersDialogComponent,
    FilterUsersPipe,
    TruncatePipe,
    VideoDialogComponent,
    SelectGroupsDialogComponent,
    FilterGroupsPipe,
    FilterUserLibraryPipe,
    AlertDialogComponent,
    CopyPlanDialogComponent,
    TemplateLibraryItemComponent,
    FeedbackComponent,
    MatPaginatorModule,
    SortPipe,
    FilterPlansPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
  ]
})
export class CoreModule { }
